import React, { useCallback, useEffect, useState } from "react";
import { ReactComponent as SearchIc } from "../../../assets/svg/search.svg";
import { ReactComponent as ImportIc } from "../../../assets/svg/import_ic.svg";
import { ReactComponent as AddIc } from "../../../assets/svg/add_icon.svg";
import { ReactComponent as EditIc } from "../../../assets/svg/edit_ic.svg";
import { ReactComponent as DeleteIc } from "../../../assets/svg/delete_ic.svg";
import { ReactComponent as RarIc } from "../../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../../assets/svg/lar_ic.svg";
import { ReactComponent as DownArrowIc } from "../../../assets/svg/down_arrow_ics.svg";
import ReactPaginate from "react-paginate";
import { Dropdown, Toast, ToastContainer } from "react-bootstrap";
import {
  getVendorGradeListApi,
  submitVendorGradeApi,
  deleteVendorGradeListApi,
  getVendorGradeByIdApi,
  updateVendorGradeListApi,
  bulkDeleteVendorGradeApi,
} from "../vendorGrade/vendorGradeApi";
import DeleteModal from "../../common/deleteModel";
import { usePermission } from "../../common/checkPermission";

export const VendorGradeList = () => {
  const { checkPermission } = usePermission();
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const [itemOffset, setItemOffset] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [createModal, setCreateModal] = useState(false);
  const [search, setSearch] = useState("");
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [vendorGradeList, setVendorGradeList] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const normalizeId = (id) =>
    id === null || id === undefined ? id : String(id);

  const toggleSelectAll = () => {
    if (!vendorGradeList || vendorGradeList.length === 0) {
      setSelectedIds([]);
      return;
    }
    const allIds = vendorGradeList.map((i) => normalizeId(i.id ?? i._id));
    if (
      selectedIds.length === allIds.length &&
      allIds.every((id) => selectedIds.includes(id))
    ) {
      setSelectedIds([]);
    } else {
      setSelectedIds(allIds);
    }
  };
  const toggleSelectOne = (id) => {
    const nid = normalizeId(id);
    setSelectedIds((prev) => {
      if (!prev) return [nid];
      if (prev.includes(nid)) return prev.filter((x) => x !== nid);
      return [...prev, nid];
    });
  };
  //   api
  const getGradeList = async () => {
    const [field, dir] = ["Created", "desc"];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: search,
      sort_field: field,
      sort_dir: dir,
    };
    try {
      const response = await getVendorGradeListApi(param);
      if (response.data.success === true) {
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setVendorGradeList(response.data.grades ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const handleEdit = async (id) => {
    try {
      setIsLoading(true);
      const resp = await getVendorGradeByIdApi(id);
      const data = resp?.data?.grade ?? resp?.data ?? {};
      setCode(data.grade_code ?? data.code ?? "");
      setName(data.grade_name ?? data.name ?? "");
      setEditingId(id);
      setErrorMsg({});
      setCreateModal(true);
    } catch (err) {
      console.error("Error fetching sub-industry:", err);
      setSnackbarMessage("Error fetching sub-industry.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };

  const [errorMsg, setErrorMsg] = useState({ grade_code: "", grade_name: "" });

  const resetForm = () => {
    setCreateModal(false);
    setEditingId(null);
    setCode("");
    setName("");
    setErrorMsg({});
  };

  const handleSave = async () => {
    if (isSaving) return;

    const trimmedCode = (code || "").trim();
    const trimmedName = (name || "").trim();
    const errors = {};

    if (!trimmedCode) {
      errors.grade_code = "Code is required";
    }
    if (!trimmedName) {
      errors.grade_name = "Grade Name is required";
    }

    if (Object.keys(errors).length > 0) {
      setErrorMsg(errors);
      return;
    }

    setIsSaving(true);
    try {
      setErrorMsg({});
      const payload = { grade_code: trimmedCode, grade_name: trimmedName };

      const response = editingId
        ? await updateVendorGradeListApi(editingId, payload)
        : await submitVendorGradeApi(payload);

      if (response?.data?.success) {
        setSnackbarMessage(
          response?.data?.message ||
            (editingId
              ? "Grade updated successfully"
              : "Grade saved successfully")
        );
        setSnackbarStatus(true);
        handleSnackbarShow();
        resetForm();
        getGradeList();
      } else {
        setErrorMsg(response?.data?.error || {});
        setSnackbarMessage(
          response?.data?.message || "Failed to save grade."
        );
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (error) {
      console.error("Error saving grade:", error);
      setSnackbarMessage("Error saving grade.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsSaving(false);
    }
  };

  const deleteVendorGrade = async () => {
    try {
      setIsLoading(true);
      if (isBulkDelete) {
        if (!selectedIds || selectedIds.length === 0) {
          setSnackbarMessage("No records selected for bulk delete.");
          setSnackbarStatus(false);
          handleSnackbarShow();
          return;
        }
        const response = await bulkDeleteVendorGradeApi(selectedIds);
        if (response?.data?.success) {
          setSnackbarMessage(response.data.message || "Bulk delete successful");
          setSnackbarStatus(true);
          handleSnackbarShow();
          setSelectedIds([]);
          setIsBulkDelete(false);
          setIsOpenDelete(false);
          getGradeList();
        } else {
          setSnackbarMessage(response?.data?.message || "Failed bulk delete");
          setSnackbarStatus(false);
          handleSnackbarShow();
        }
      } else {
        if (!deleteId) return;
        const response = await deleteVendorGradeListApi(deleteId);
        if (response?.data?.success) {
          setSnackbarMessage(response.data.message || "Deleted successfully");
          setSnackbarStatus(true);
          handleSnackbarShow();
          setDeleteId(null);
          setIsOpenDelete(false);
          getGradeList();
        } else {
          setSnackbarMessage(response?.data?.message || "Failed to delete");
          setSnackbarStatus(false);
          handleSnackbarShow();
        }
      }
    } catch (err) {
      console.error(err);
      setSnackbarMessage("Error deleting record.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getGradeList();
  }, [itemsPerPage, itemOffset, search]);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  return (
    <div>
      <DeleteModal
        isOpen={isOpenDelete}
        title={
          isBulkDelete ? `selected (${selectedIds.length}) grades` : "grade"
        }
        onClose={() => {
          setIsOpenDelete(false);
          setDeleteId(null);
          setIsBulkDelete(false);
        }}
        onDelete={deleteVendorGrade}
      />
      <div
        className="bg-white p-3"
        style={{
          borderBottomRightRadius: "16px",
          borderBottomLeftRadius: "16px",
        }}
      >
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
          <p className="m-0 textGrey fs-13 fw-500">
            Total counts : {totalCount ?? 0}
          </p>
          <div className="d-flex gap-3 flex-wrap">
            {/* Search */}
            <div className="search-wrapper border bg-transparent d-flex align-items-center gap-2 px-3 py-2">
              <SearchIc />
              <input
                type="text"
                placeholder="Search"
                className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor bg-transparent"
                value={search || ""}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            {/* Add New*/}
            {selectedIds.length === 0 && (
              <>
                {" "}
                {checkPermission("Vendor Grade", "create_permission") && (
                  <div
                    className="cursor-pointer my-box d-flex align-items-center justify-content-center gap-2 px-3"
                    onClick={() => setCreateModal(true)}
                    style={{ height: "40px" }}
                  >
                    <AddIc width={14} height={14} />
                    <div className="fs-14 fw-700 textWhitecolor">New Grade</div>
                  </div>
                )}
              </>
            )}

            {/* Bulk Delete button */}
            {selectedIds.length > 0 && (
              <>
                {checkPermission("Vendor Grade", "delete_permission") && (
                  <div
                    className="cursor-pointer my-box d-flex align-items-center justify-content-center gap-2 px-3"
                    style={{ height: "40px" }}
                    onClick={() => {
                      setIsBulkDelete(true);
                      setIsOpenDelete(true);
                    }}
                  >
                    <DeleteIc
                      style={{
                        filter:
                          "invert(1) sepia(1) saturate(5) hue-rotate(180deg) brightness(2)",
                      }}
                    />
                    <div className="fs-14 fw-700 textWhitecolor">Delete</div>
                  </div>
                )}
              </>
            )}

            {/* Import  */}
            {/* <div
              className="my-import d-flex align-items-center justify-content-center gap-2"
              style={{ height: "40px" }}
            >
              <ImportIc />
              <div className="fs-14 fw-700 textPurple">Import</div>
            </div> */}
          </div>
        </div>
        <div className="bg-white rounded-4 mt-3 w-100 ">
          <div
            style={{
              display: "flex",
              flex: "10",
              paddingLeft: "16px",
              paddingRight: "16px",
              paddingTop: "16px",
              height: "40px",
              backgroundColor: "#F2F2F2",
            }}
            className="head3 w-100 justify-content-center align-items-center"
          >
            {checkPermission("Vendor Grade", "delete_permission") && (
              <input
                type="checkbox"
                checked={
                  vendorGradeList.length > 0 &&
                  selectedIds.length === vendorGradeList.length
                }
                onChange={toggleSelectAll}
                style={{ marginRight: "8px", marginBottom: "14px" }}
              />
            )}
            <p
              style={{ width: "127px", flex: "1.5" }}
              className="fs-13 fw-700 textcolor"
            >
              Code
            </p>
            <p
              style={{ width: "160px", flex: "1.5" }}
              className="fs-13 fw-700 textcolor"
            >
              Vendor Grade
            </p>
          </div>
          <div>
            {(vendorGradeList ?? []).map((item, index) => (
              <div
                style={{
                  display: "flex",
                  flex: "10",
                  paddingLeft: "16px",
                  paddingRight: "16px",

                  backgroundColor:
                    hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                  borderBottom: "1px solid #D4DDE7",
                  cursor: "pointer",
                  height: "44px",
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                className="head3 w-100 justify-content-center align-items-center"
              >
                {checkPermission("Vendor Grade", "delete_permission") && (
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(
                      normalizeId(item.id ?? item._id),
                    )}
                    onChange={(e) => {
                      e.stopPropagation();
                      toggleSelectOne(item.id ?? item._id);
                    }}
                    style={{
                      marginRight: "8px",
                      marginBottom: "0px",
                    }}
                  />
                )}
                <p
                  className="fs-13 fw-500 textcolor"
                  style={{
                    flex: "1.5",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    marginTop: "16px",
                  }}
                  title={item.grade_code}
                >
                  {item.grade_code ?? "---"}
                </p>
                <p
                  className="fs-13 fw-500 textcolor"
                  style={{
                    flex: "1.5",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    marginTop: "16px",
                  }}
                  title={item.grade_name}
                >
                  {item.grade_name ?? "---"}
                </p>
                {hoveredIndex === index && (
                  <div
                    style={{
                      position: "absolute",
                      // top: "50%",
                      right: "35px",
                      // transform: "translate(-50%, -50%)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                    >
                      {checkPermission("Vendor Grade", "edit_permission") && (
                        <div
                          onClick={async (e) => {
                            e.stopPropagation();
                            handleEdit(item.id);
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "28px",
                            height: "28px",
                            borderRadius: "100px",
                            background: "#FFFFFF",
                            cursor: "pointer",
                            border: "0.8px solid #E5E5E5",
                          }}
                        >
                          <EditIc />
                        </div>
                      )}
                      <span style={{ marginLeft: "16px" }}></span>
                      {checkPermission("Vendor Grade", "delete_permission") && (
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            setDeleteId(item.id);
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "28px",
                            height: "28px",
                            borderRadius: "100px",
                            background: "#FFFFFF",
                            cursor: "pointer",
                            border: "0.8px solid #E5E5E5",
                          }}
                        >
                          <DeleteIc />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className=" d-flex justify-content-between align-items-center flex-wrap gap-3 me-3 ms-3">
        <Dropdown>
          <span className="pagination-color fs-13 fw-500 ">
            Records per page: &nbsp;
          </span>
          <Dropdown.Toggle
            id="dropdown-basic"
            className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0"
          >
            <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
              {itemsPerPage} <DownArrowIc />
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu
            className="my-2"
            style={{ minWidth: "unset", width: "40%" }}
          >
            {[10, 25, 50, 75, 100].map((size) => (
              <Dropdown.Item
                key={size}
                onClick={() => {
                  setItemsPerPage(size);
                }}
                active={itemsPerPage === size}
                className="text-center"
              >
                {size}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <div className="d-flex align-items-center gap-2">
          <ReactPaginate
            previousLabel={
              <div
                className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                style={{
                  width: "32px",
                  height: "32px",
                }}
              >
                <LarIc />
              </div>
            }
            nextLabel={
              <div
                className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                style={{
                  width: "32px",
                  height: "32px",
                }}
              >
                <RarIc />
              </div>
            }
            breakLabel={"..."}
            pageCount={pageCount + 1}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
          />
        </div>
      </div>{" "}
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      {/* New Industry Modal */}
      {createModal && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop fade show"
            style={{ zIndex: 1040 }}
          ></div>

          {/* Modal */}
          <div
            className="modal show d-block"
            tabIndex="-1"
            style={{ zIndex: 1050 }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content rounded-4 p-3">
                <div className="modal-header border-0">
                  <h5 className="modal-title fs-20 fw-700">
                    {editingId ? "Edit Grade" : "New Grade"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close border rounded-circle"
                    onClick={resetForm}
                  ></button>
                </div>

                {/* Body */}
                <div className="modal-body">
                  <form>
                    <div className="mb-3">
                      <label className="form-label">
                        {" "}
                        Code <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Code"
                        value={code}
                        onChange={(e) => {
                          setCode(e.target.value);
                          if (errorMsg.grade_code) {
                            setErrorMsg((prev) => ({
                              ...prev,
                              grade_code: "",
                            }));
                          }
                        }}
                      />
                      <div>
                        {errorMsg.grade_code && (
                          <span
                            className="text-danger"
                            style={{ fontSize: 12 }}
                          >
                            {Array.isArray(errorMsg.grade_code)
                              ? errorMsg.grade_code[0]
                              : errorMsg.grade_code}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Grade Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Name"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                          if (errorMsg.grade_name) {
                            setErrorMsg((prev) => ({
                              ...prev,
                              grade_name: "",
                            }));
                          }
                        }}
                      />
                      <div>
                        {errorMsg.grade_name && (
                          <span
                            className="text-danger"
                            style={{ fontSize: 12 }}
                          >
                            {Array.isArray(errorMsg.grade_name)
                              ? errorMsg.grade_name[0]
                              : errorMsg.grade_name}
                          </span>
                        )}
                      </div>
                    </div>
                  </form>
                </div>

                {/* Footer */}
                <div className="modal-footer gap-3 border-0">
                  <button
                    className="btn bg-transparent border px-3"
                    type="button"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn text-white px-4 d-flex align-items-center justify-content-center"
                    type="button"
                    style={{
                      backgroundColor: "#4F46E5",
                      minWidth: "90px",
                      opacity: isSaving ? 0.7 : 1,
                      height: "36px",
                    }}
                    onClick={handleSave}
                    disabled={isSaving}
                  >
                    {isSaving ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
